export function getOrdinal(num, lang = 'en', specialRanks = false) {
    // English ordinals
    const englishOrdinals = ["th", "st", "nd", "rd"];
    
    // Arabic ordinals from 1st to 20th
   const arabicOrdinals = [
    "الأول",        // 1
    "الثاني",       // 2
    "الثالث",       // 3
    "الرابع",       // 4
    "الخامس",       // 5
    "السادس",       // 6
    "السابع",       // 7
    "الثامن",       // 8
    "التاسع",       // 9
    "العاشر",       // 10
    "الحادي عشر",   // 11
    "الثاني عشر",   // 12
    "الثالث عشر",   // 13
    "الرابع عشر",   // 14
    "الخامس عشر",   // 15
    "السادس عشر",   // 16
    "السابع عشر",   // 17
    "الثامن عشر",   // 18
    "التاسع عشر",   // 19
    "العشرون",      // 20
    "الحادي والعشرون",  // 21
    "الثاني والعشرون",  // 22
    "الثالث والعشرون",  // 23
    "الرابع والعشرون",  // 24
    "الخامس والعشرون",  // 25
    "السادس والعشرون",  // 26
    "السابع والعشرون",  // 27
    "الثامن والعشرون",  // 28
    "التاسع والعشرون",  // 29
    "الثلاثون"          // 30
];

if(num == null){
    return'';
}
    // Special ranks: Golden, Silver, Bronze
    const englishSpecial = ["Gold", "Silver", "Bronze"];
    const arabicSpecial = ["\u0630\u0647\u0628\u064A", "\u0641\u0636\u064A", "\u0628\u0631\u0648\u0646\u0632\u064A"];

    const mod100 = num % 100;
    const mod10 = num % 10;
    let suffix;

    if (specialRanks && num <= 3) {
        if (lang === 'en') {
            return englishSpecial[num - 1];
        } else if (lang === 'ar') {
            return arabicSpecial[num - 1];
        }
    }

    if (lang === 'en') {
        if (mod100 >= 11 && mod100 <= 13) {
            suffix = englishOrdinals[0]; // 'th' for 11th, 12th, 13th
        } else {
            suffix = englishOrdinals[mod10] || englishOrdinals[0]; // st, nd, rd, th
        }
        return `<span>${num}<sup>${suffix}</sup></span>`;
    } else if (lang === 'ar') {
        // Use Arabic ordinals for numbers from 1 to 20
        if (num >= 1 && num <= 20) {
            suffix = arabicOrdinals[num - 1];
            return suffix;
        } else {
            return "\u0640"; // Default for larger numbers: no suffix
        }
    }
}
